import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=a0fbcc70&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=a0fbcc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fbcc70",
  null
  
)

export default component.exports